import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { LogoutService } from './logout.service';
import { HttpAuth } from '../httpauth/http-auth.service';
import { environment } from '../../../environments/environment';
import { AppStorage } from '@services/storage/appstorage.service';
import { LoggerService } from '@services/logger/logger.service';
import { Utils } from '@services/utils/utils';

export enum ROLES {
	ADMIN,
	SUPERADMIN
}

@Injectable()
export class LoginUtils {
	public user$ = new Subject();
	private userSession;
	public roles;

	constructor(
		private log: LoggerService,
		private storage: AppStorage,
		private translate: TranslateService,
		private logoutservice: LogoutService,
		private http: HttpAuth,
		private router: Router
	) {
		this.log.debug('LoginUtils', this);
		this.storage.getAsync('user').subscribe(user => (this.user = user));
		this.checkLogout();
		this.roles = Utils.listFromEnum(ROLES);
	}

	public checkLogout() {
		this.logoutservice.status.subscribe(() => this._logout());
	}

	public get user() {
		return this.userSession;
	}

	public set user(user) {
		this.storage.setAsync('user', user).subscribe(res => {
			this.userSession = user;
			this.emitUserChanges();
		});
	}

	public get isLogged() {
		return !_.isEmpty(this.userSession) && this.userSession;
	}

	private emitUserChanges() {
		this.user$.next(this.userSession);
	}

	private _logout() {
		const logout = () =>
			this.storage.deleteAsync('user').subscribe(sres => {
				this.router.navigate(['/login']);
				this.userSession = null;
			});
		this.http.post('/logout', {}).subscribe(logout, logout);
	}

	public useLang(lang: string) {
		const langsMatch = environment.availableLangs
			? new RegExp(environment.availableLangs.join('|'), 'gi')
			: /en/;
		const defaultLang = environment.language;
		let outputLang = defaultLang;

		if (lang && lang.match(langsMatch)) {
			this.translate.use(lang);
			outputLang = lang;

			this.log.log(`[LANGUAGE] Choosen by user: ${lang}`);
		} else {
			const browserLang = this.translate.getBrowserLang();
			const cond = browserLang.match(langsMatch) ? browserLang : defaultLang;
			this.translate.use(cond);
			outputLang = cond;

			this.log.log(`[LANGUAGE] Default: ${cond}`);
		}

		this.storage.setAsync('lang', outputLang).subscribe();
	}

	isRoleSufficient(roles: string | string[]) {
		const userRoles = [this.user.role];
		const askedRoles = typeof roles !== 'object' ? [roles] : roles;
		const contains = userRoles.filter(item => askedRoles.indexOf(item) > -1);
		return !!contains.length;
	}

	isPermitted(perms: string[]): boolean {
		const currentPerms = this.user.permissions || [this.user.role];
		const compare = currentPerms.filter(item => perms.includes(item));
		return compare && compare.length ? !!compare.length : false;
	}
}
